import { EndpointsOptionsMap } from '../system';
import * as rolesApi from './roles';

export type RolesApiEndpointTypes = EndpointsOptionsMap<typeof rolesApi>;
export { rolesApi };
